export default "__VITE_ASSET__C30Pxz7P__"